import {
	MAX_PREDICTION_PRICE,
	BigNum,
	PRICE_PRECISION,
	PRICE_PRECISION_EXP,
} from '@drift-labs/sdk';

export const MAX_PREDICTION_PRICE_NUM =
	MAX_PREDICTION_PRICE.div(PRICE_PRECISION).toNumber();

export const MAX_PREDICTION_PRICE_BIG_NUM = BigNum.from(
	MAX_PREDICTION_PRICE,
	PRICE_PRECISION_EXP
);
